export const SESSION_PROFILE_KEY = 'auth.session.profile'
export const SESSION_USER_ID_KEY = 'auth.session.user-id'
export const SESSION_CLEARED_EVENT = 'auth-session-cleared'

/**
 * 清除浏览器中持久化的会话摘要，并按需广播会话失效事件。
 *
 * @param {Object} options 清理选项
 * @param {Storage} options.storage Web Storage 实例
 * @param {Window|null} options.eventTarget 事件目标
 * @param {boolean} options.notify 是否广播会话清理事件
 * @returns {void}
 */
export function clearStoredSessionProfile({
  storage,
  eventTarget = null,
  notify = true,
} = {}) {
  try {
    storage?.removeItem(SESSION_PROFILE_KEY)
    storage?.removeItem(SESSION_USER_ID_KEY)
  } catch { /* 禁用存储时也必须广播会话失效，清除页面内存与权限。 */ }

  if (!notify || !eventTarget) return
  const EventConstructor = eventTarget.Event
  eventTarget.dispatchEvent(new EventConstructor(SESSION_CLEARED_EVENT))
}
